"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.licenseAttributeMapping = void 0;
exports.licenseAttributeMapping = {
    GD_DESKTOP_BACKGROUND: {
        mapAttributes: ['desktopBackground'],
        licenseAttribute: 'gdDesktopBackground',
    },
    GD_AUDIO: {
        mapAttributes: [],
        licenseAttribute: 'gdAudio',
    },
    GD_CHOOSE_IMAGE: {
        mapAttributes: ['buttonBackgroundImage'],
        licenseAttribute: 'gdChooseImage',
    },
    GD_START_TEXT: {
        mapAttributes: ['textWhenActive', 'textBeforeStart', 'textWhenExpire'],
        licenseAttribute: 'gdStartText',
    },
    GD_HIGH_SCORE_TEXT: {
        mapAttributes: ['highScoreText', 'previousScoreText'],
        licenseAttribute: 'gdHighscoreText',
    },
    GD_RANKING_TEXT: {
        mapAttributes: ['rankingText'],
        licenseAttribute: 'gdRankingText',
    },
    GS_SPLIT_GAME: {
        mapAttributes: ['hasSplitGame'],
        licenseAttribute: 'gsSplitGame',
    },
    GS_CHANGE_FONT: {
        mapAttributes: ['font'],
        licenseAttribute: 'gsChangeFont',
    },
    GS_LEADERBOARD: {
        mapAttributes: [],
        licenseAttribute: 'gsLeaderBoard',
    },
    GS_EXTERNAL_LEADERBOARD: {
        mapAttributes: [],
        licenseAttribute: 'gsExternalLeaderBoard',
    },
    GS_PRIZES: {
        mapAttributes: [],
        licenseAttribute: 'gsPrizes',
    },
    GS_CHALLENGE: {
        mapAttributes: [],
        licenseAttribute: 'gsChallenge',
    },
    GS_WELCOME_EMAIL: {
        mapAttributes: [],
        licenseAttribute: 'gsWelcomeEmail',
    },
    GS_TUTORIAL: {
        mapAttributes: [],
        licenseAttribute: 'gsTutorial',
    },
    GS_LUCK_BASED_WINS_ENABLED: {
        mapAttributes: [],
        licenseAttribute: 'gsLuckBasedWinsEnabled',
    },
    GA_DATA_EXPORT: {
        mapAttributes: [],
        licenseAttribute: 'gaDataExport',
    },
    GA_GENERATE_WINNERS: {
        mapAttributes: [],
        licenseAttribute: 'gaGenerateWinners',
    },
    ANALYTICS_ENABLED: {
        mapAttributes: [],
        licenseAttribute: 'analyticsEnabled',
    },
    ASSETS_FONT_ENABLED: {
        mapAttributes: [],
        licenseAttribute: 'assetsFontEnabled',
    },
    GC_ENABLED: {
        mapAttributes: ['status'],
        licenseAttribute: 'gcEnabled',
    },
    BRAND_USER_BASE_ENABLED: {
        mapAttributes: [],
        licenseAttribute: 'brandUserBaseEnabled',
    },
    BRAND_USER_BASE_EXPORT: {
        mapAttributes: [],
        licenseAttribute: 'brandUserBaseExport',
    },
    BRAND_USER_BASE_SEND_EMAIL: {
        mapAttributes: [],
        licenseAttribute: 'brandUserBaseSendEmail',
    },
    GAMIFICATION_ENABLED: {
        mapAttributes: [],
        licenseAttribute: 'gamificationEnabled',
    },
    DATA_INTEGRATION_ENABLED: {
        mapAttributes: [],
        licenseAttribute: 'dataIntegrationEnabled',
    },
};
